<template>
  <div class="columns">
    <div class="column is-12">
      <v-tabs
          background-color="primary"
          center-active
          dark
          v-model="tab"
      >
        <v-tab v-for="(tab,index) in tabsList" :key="index">{{ tab }}</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="(tab,index) in tabsShortNames" :key="index">
          <froala
              v-model="rulesData[tab]"
              :config="config"
              :tag="'textarea'"
          />
        </v-tab-item>
      </v-tabs-items>
      <v-btn @click="saveRules" color="primary">Save</v-btn>
    </div>
  </div>
</template>
<style scoped>
.ahlblue {
  color: #4267b2
}
</style>
<script>
import axios from 'axios'

export default {
  name: 'ToolsEditRules',
  props: ['token', 'user', 'loginUser'],
  data() {
    return {
      config: {
        /*key: 'GPD2tA17B2A2C1A1B1sqyI-7cB-22C-16seD2zuvc1A6B5A4D3A3B2B2G3A4A3==',
        imageUploadParam: 'file',
        imageUploadURL: 'https://rest.ahlpoker.com/image/upload',
        imageUploadParams: {
          id: 'my_editor',
          token: ''
        },
        imageUploadMethod: 'POST',
        imageMaxSize: 5 * 1024 * 1024,
        imageAllowedTypes: ['jpeg', 'jpg', 'png'],
        imageManagerLoadMethod: 'GET',
        imageManagerLoadURL: 'https://rest.ahlpoker.com/image/getlist',
        imageManagerDeleteURL: 'https://rest.ahlpoker.com/image/delete',
        events: {
          'froalaEditor.image.loaded': (e, editor, $img) => {
            this['_data'].images.push($img[0].src)
          },
          'froalaEditor.image.removed': (e, editor, $img) => {
            let index = this['_data'].images.find((image) => {
              return image === $img[0].src
            })
            this['_data'].images.splice(index, 1)
          }
        }*/
      },
      rulesData: {},
      tab: null,
      tabsList: [
        'AHL PRIZES AND EVENTS',
        'OFFICIAL AHL TOURNAMENT RULES',
        'TOURNAMENT POINTS',
        'TOURNAMENT STRUCTURE'
      ],
      tabsShortNames: [
        'AHLPRIZESANDEVENTS',
        'OFFICIALAHLTOURNAMENTRULES',
        'TOURNAMENTPOINTS',
        'TOURNAMENTSTRUCTURE'
      ]
    }
  },
  mounted: function () {
    this.getRules()
  },
  methods: {
    saveRules() {
      let url = `admin/rules/saverules`
      let data = {
        token: this.token,
        rulesData:{}
      };

      this.tabsShortNames.forEach((tab) => {
        data.rulesData[tab] = this.rulesData[tab];
      });

      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.$emit('message', {showDialog: true, message: res.data.message});
          }).catch((error) => {
        this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
      });
    },
    getRules() {
      let url = `general/getrules`
      let data = {
        token: this.token
      }
      this.$axios({
        method: 'POST',
        url,
        headers: {
          Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        data
      })
          .then((res) => {
            this.rulesData = res.data
          })
          .catch((error) => {
            this.$emit('message', {error: true, message: error.response.data.message})
          })
    },
  }
}
</script>
